// extracted by mini-css-extract-plugin
module.exports = {"toggleSection":"Notifications_toggleSection__3PNBP"};